module.exports = __webpack_public_path__ + "static/img/main6_1.34fe5301.png";